const React = require('react');
const upperFirst = require('mn-utils/upperFirst');
const DefaultSelect = require('../../../../../Select/I');

module.exports = ({selectParams, data, onChange, disabled, selectComponent}) => {
  const Select = selectComponent || DefaultSelect;
  const {name, placeholder, className, list} = selectParams;
  const items = [{id: 'all'}, ...list];
  return (
    <Select
      className={`f12 lh17 fw7 ${className ? ` ${className}` : ''}`}
      placeholder={placeholder}
      propName={(v) => {
        return v.name ? v.name : upperFirst(v.id).replace('_', ' ');
      }}
      propValue="id"
      value={data[name] || 'all'}
      items={items}
      onChange={(id) => {
        onChange({
          ...data,
          [name]: id !== 'all' ? id : null,
        });
      }}
      disabled={disabled}
    />
  );
};
